export default __webpack_public_path__ + "static/media/Bandit's Armbands of the Grasping Wild.937e993a.jpg";